// removed by extract-text-webpack-plugin
module.exports = {"root":"PasswordResetForm__root__29Uyc","password":"PasswordResetForm__password__GpVtw"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/PasswordResetForm/PasswordResetForm.css
// module id = 1726
// module chunks = 0